// extracted by mini-css-extract-plugin
export default {"retrievalContainer":"orderRetrival_retrievalContainer__Psc+W","Ws14Container":"orderRetrival_Ws14Container__htzX1"};